var empty = null;

export { empty as default };
//# sourceMappingURL=empty.js.map
